import React from 'react';
import { IconButton, useColorMode, Tooltip } from '@chakra-ui/react';
import { SunIcon, MoonIcon } from '@chakra-ui/icons';

export default function ThemeToggle({ size = 'md', showTooltip = true }) {
  const { colorMode, toggleColorMode } = useColorMode();

  const button = (
    <IconButton
      aria-label="Toggle theme"
      icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
      onClick={toggleColorMode}
      size={size}
      variant="ghost"
      colorScheme="blue"
      borderRadius="full"
      _hover={{
        bg: colorMode === 'light' ? 'gray.100' : 'gray.700',
      }}
    />
  );

  if (showTooltip) {
    return (
      <Tooltip 
        label={colorMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
        placement="bottom"
        hasArrow
      >
        {button}
      </Tooltip>
    );
  }

  return button;
}